
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindShaft5 as ObiWindShaft5Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-shaft-5.js';
 
 
 

 
 export const ObiWindShaft5 = createComponent({
   react: React,
   tagName: 'obi-wind-shaft-5',
   elementClass: ObiWindShaft5Element,
   events: {
     
   }
  });
 
 